import { observer } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';

export type MediaFormat = 'mp4' | 'png' | 'gif';

interface FormatDropdownProps {
  onSelectFormat: (format: MediaFormat) => void;
  buttonRect: DOMRect;
  additionalHeight?: number;
}

export const FormatDropdown = observer(
  React.forwardRef<HTMLDivElement, FormatDropdownProps>((props, ref) => {
    const { onSelectFormat, buttonRect, additionalHeight } = props;
    const top =
      buttonRect.top + buttonRect.height + (additionalHeight || 0) + 5;
    const left = buttonRect.left;

    return (
      <DropdownContainer ref={ref} top={top} left={left}>
        <DropdownItem
          onClick={() => {
            onSelectFormat('mp4');
          }}
        >
          <span>MP4 Video</span>
        </DropdownItem>
        <DropdownItem
          onClick={() => {
            onSelectFormat('png');
          }}
        >
          <span>PNG Image</span>
        </DropdownItem>
        <DropdownItem
          onClick={() => {
            onSelectFormat('gif');
          }}
        >
          <span>GIF Animation</span>
        </DropdownItem>
      </DropdownContainer>
    );
  }),
);

FormatDropdown.displayName = 'FormatDropdown';

const DropdownContainer = styled.div<{ top: number; left: number }>`
  position: fixed;
  top: ${props => props.top}px;
  left: ${props => props.left}px;
  background-color: var(--background);
  border: 1px solid var(--border);
  border-radius: 8px;
  z-index: 1000;
  box-shadow: var(--elevation-xs);
  min-width: 180px;
`;

const DropdownItem = styled.div`
  color: var(--text-secondary);
  font-size: var(--text-xs);
  line-height: 14.52px;
  font-weight: var(--font-weight-regular);
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 20px 16px 20px 16px;
  transition: all var(--transition-normal);

  span {
    text-transform: capitalize;
  }

  &:hover {
    color: var(--background);
    background-color: var(--primary);
  }

  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid var(--border);
    padding-bottom: 20px;
  }
`;
